import { Stops_LineTypeEnum } from 'src/api/gen'

import busSvg from './bus.svg'
import subwaySvg from './subway.svg'
import trainSvg from './train.svg'
import tramSvg from './tram.svg'

export const INFRASTRUCTURE_STOPS_ICONS = {
  [Stops_LineTypeEnum.bus]: busSvg,
  [Stops_LineTypeEnum.subway]: subwaySvg,
  [Stops_LineTypeEnum.train]: trainSvg,
  [Stops_LineTypeEnum.tram]: tramSvg,
}

export const INFRASTRUCTURE_STOPS_PRIORITY = {
  [Stops_LineTypeEnum.bus]: 1,
  [Stops_LineTypeEnum.subway]: 3,
  [Stops_LineTypeEnum.train]: 4,
  [Stops_LineTypeEnum.tram]: 2,
}
